import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Callee {
  uuid: string;
  number: string;
  answerState: string;
}

export interface CallFlowEntry {
  time: string;
  number: string;
}

export interface LiveCall {
  callUUID: string;
  callerIDName: string;
  callerIDNumber: string;
  startTime: string;
  duration: string;
  answerState: string;
  callees: Callee[];
  callDirection?: "inbound" | "outbound";
  callFlow?: CallFlowEntry[];
  destination: string;
  dialedNumber: string;
  isHolding?: boolean;
  isParked?: boolean;
  isRecording?: boolean;
  answerTime?: string;
}

interface LiveCallsState {
  calls: LiveCall[];
}

const initialState: LiveCallsState = {
  calls: [],
};

const liveCallsSlice = createSlice({
  name: "liveCalls",
  initialState,
  reducers: {
    setLiveCalls: (state, action: PayloadAction<LiveCall[]>) => {
      state.calls = action.payload;
    },
    addOrUpdateLiveCall: (state, action: PayloadAction<LiveCall>) => {
      const index = state.calls.findIndex(call => call.callUUID === action.payload.callUUID);
      if (index !== -1) {
        if (action.payload.answerState == "hangup") {
          state.calls.splice(index, 1);
        } else {
          state.calls[index] = action.payload;
        }
      } else {
        state.calls.push(action.payload);
      }
    },
    removeLiveCall: (state, action: PayloadAction<string>) => {
      state.calls = state.calls.filter(call => call.callUUID !== action.payload);
    },
  },
});

export const { setLiveCalls, addOrUpdateLiveCall, removeLiveCall } = liveCallsSlice.actions;
export default liveCallsSlice.reducer;
